import { useNavigate } from 'react-router'
import { ProvisionWizard } from '@/components/tenants/ProvisionWizard'

/**
 * /tenants/new — Dedicated route for the provision wizard.
 *
 * Having this as a route means the auth guard runs on navigation,
 * catching expired tokens before the user fills out the wizard.
 */
export default function NewTenantPage() {
  const navigate = useNavigate()

  return (
    <ProvisionWizard
      isOpen={true}
      onClose={() => navigate('/tenants')}
      onComplete={() => navigate('/tenants')}
    />
  )
}
